import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../../store/context/simple-context";
import parse from "html-react-parser";

const ComplexTooltip = ({ name }) => {
  const {
    translate: { t },
  } = useContext(SimpleContext);
  return (
    <>
      {name === "+ 2 AWESOME BONUSES" && (
        <>
          <p>
            {parse(
              t(
                "One-on-One Mentor Call - Get personal guidance during a 30-minute call from proven Amazon six- or seven-figure sellers. Discuss your plan for launch your own business on Amazon or strategize changes for your existing business."
              )
            )}
          </p>
          <p>
            {parse(
              t(
                "Booming Product Idea - Discover a ready-to-launch product backed by full Amazon niche analytics, top-ranked keywords, and verified supplier examples."
              )
            )}
          </p>
        </>
      )}
    </>
  );
};
ComplexTooltip.propTypes = {
  name: PropTypes.string.isRequired,
};
export default ComplexTooltip;
